<template>
<CampaignOverview
    :title=descripcio
    :code=id
    :dateFrom=data_ini
    :dateTo=data_fi
    :productName=servei
    :productCode=servei2
    :controlPointsCount=num_fotos
    :quantitatBotiguesET=quantitat_botigues_ET
    :totalUnits=quantitat
    :deliveredUnits=quantitat_distribuida
    :pendingUnits=quantitat-quantitat_distribuida
    :totalUnitsET=quantitatET
    :deliveredUnitsET=quantitatET_distribuida
    :pendingUnitsET=quantitatET-quantitatET_distribuida
    :imageUrl="img || ClientImage || ClientLogo"
    :idCampET = idCampET
    :nomServeiInicial = servei
    @openModalFotos="mostrarModalFotos = true"
    @updateServei="onUpdateServei"
  />

  <!-- Mapa -->
  <v-row>
  <!-- Columna del mapa - només si NO hi ha idCampET -->

  <v-col
    v-if="!visibleET"
    cols="6"
    class="ma-0 pa-0"
  >
    <MapaReparto
      :urlMapa="urlMapa"
      v-model:startMinimized="startMinimizedMapa"
      v-model:visibleMapa="visibleMapa"
    />
  </v-col>

  <!-- Columna de les taules -->
  <v-col
    :cols="visibleET ? 12 : 6"
    class="ma-0 pa-0"
  >
    <LiniesCampanyaTable
      titol="ZONAS DE REPARTO"
      :items="LiniesCampBM.campaignsLines.value"
      :headers="LiniesCampBM.headers.value"
      v-model:start-minimized="startMinimized"
      v-model:visible="visibleBM"
      @mapa="mapaLinia"
      @exportar="exportarTaula"
    />

    <LiniesCampanyaTable
      v-if="idCampET"
      titol="ENTREGAS EN TIENDA"
      :items="LiniesCampET.campaignsLines.value"
      :headers="LiniesCampET.headers.value"
      v-model:start-minimized="startMinimizedET"
      v-model:visible="visibleET"
      @mapa="mapaLinia"
      @exportar="exportarTaula"
    />
  </v-col>
</v-row>

  <!-- Modal del mapa de botigues -->
  <MapaBotiguesModal
    v-model="showMapaLinia"
    :url-mapa="urlMapaLinia"
    :provincia="ProvinciaMapaLinia"
    :poblacio="PoblacioMapaLinia"
    :zona="ZonaMapaLinia"
  />

  <!--  Modal llistat fotos -->
  <LlistatFotosModal v-model="mostrarModalFotos" :llistat-fotos="llistatFotos" @foto-deleted="onFotoDeleted" />

</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRoute } from 'vue-router'
import { netejaDescripcio, formatNumber, formatDateRange, formatDate } from '@/utils/text-utils'
import { estats, estatActual, calcularEstatActual, loadServeis, existeixEntregaTienda } from '@/composables/CampaignList/UseEstatsCamp.js'
import { useLiniesCampanya } from '@/composables/CampaignInfo/useLiniesCampanya.js'
import LiniesCampanyaTable from '@/composables/CampaignInfo/LiniesCampanyaTable.vue'
import MapaReparto from '@/composables/CampaignInfo/MapaReparto.vue'
import LlistatFotosModal from '@/composables/CampaignInfo/LlistatFotosModal.vue'
import MapaBotiguesModal from '@/composables/CampaignInfo/MapaBotiguesModal.vue'

import CampaignOverview from '@/composables/CampaignInfo/CampaignOverview.vue'

// Capçalera
const ClientId = ref('')
const route = useRoute()
const id = ref('')
const descripcio = ref('')
const servei = ref('')
const servei2 = ref('')
const estat = ref('')
const data_ini = ref('')
const data_fi = ref('')
const notes = ref('')
const img = ref('')
const quantitat = ref(0)
const quantitat_distribuida  = ref(0)
const quantitatET = ref(0)
const quantitatET_distribuida  = ref(0)
const per_distribuida  = ref(0)
const num_fotos  = ref(0)
const mapa = ref('')
const mapaFiltreBotiga = ref('')
const idCampET = ref(false)
const ampliaImg = ref(false)

// MAPA
const urlMapa = ref('')
const showMapaLinia = ref(false)
const urlMapaLinia = ref('')
const ProvinciaMapaLinia = ref('')
const PoblacioMapaLinia = ref('')
const ZonaMapaLinia = ref('')

// FOTOS / PUNTS DE CONTROL
const mostrarModalFotos = ref(false);
const llistatFotos = ref([])

// Taula
const search = ref('')

const LiniesCampBM = useLiniesCampanya()
const LiniesCampET = useLiniesCampanya()
const quantitat_botigues_ET = ref(0)

const startMinimized = ref(false)
const startMinimizedET = ref(true)
const startMinimizedMapa = ref(false)
const visibleBM = ref(true)
const visibleET = ref(false)
const visibleMapa = ref(true)

const clientSession = ref([])
const admin = ref(false)
const ClientLogo = ref('')
const ClientImage = ref('')
const fotos_al_mapa = ref(false)

const botigaFiltre = ref(route.params.shop || '')

// ID de Campanya -> URL
const idCamp = encodeURIComponent(route.params.idOdoo)

//const headers = ref([...headersBase])

const CapCampanya = async () => {

    const { data } = await axios.post('/api/ListCamp', {
        ClientId: ClientId.value,
        id: idCamp
    });

    id.value = data[0].name
    descripcio.value = netejaDescripcio(data[0].description)
    servei.value = data[0].service_type_id[1]
    estat.value = data[0].state
    data_ini.value = data[0].start_date
    data_fi.value = data[0].end_date
    notes.value = data[0].customer_note
    mapa.value = (data[0].map) ?  data[0].map : ''
    mapaFiltreBotiga.value = data[0].filter_shop

    if (servei.value.includes('(')) {
      const parts = servei.value.split('(')
      servei2.value = '(' + parts[1].trim()
      servei.value = parts[0].trim()
    } else {
      // Si no hi ha '(', mantens el valor original
      servei2.value = ''
      servei.value = servei.value.trim()
    }

    // Buscar imatge i descripció agrupada
    const  data2  = await axios.get('/api/campaignsWeb/by-idCamp/'+idCamp, {});
    img.value = data2.data.img
    if (data2.data.desc_agrupada !='') descripcio.value = netejaDescripcio(data2.data.desc_agrupada)

    //Linies BM
    await LiniesCampBM.loadLinies(idCamp, ClientId.value, botigaFiltre.value)

    quantitat.value = LiniesCampBM.quantitat.value
    quantitat_distribuida.value = LiniesCampBM.quantitat_distribuida.value
    per_distribuida.value = LiniesCampBM.per_distribuida.value

    //ZT per buscar les fotos
    const zonesUniques = [...new Set(LiniesCampBM.campaignsLines.value.map(i => i.zone_id))]

    //Entrega en tienda
    //console.log (existeixEntregaTienda(idCamp))
    if ((idCampET.value = existeixEntregaTienda(idCamp)) != null) {
      await LiniesCampET.loadLinies(idCampET.value, ClientId.value, botigaFiltre.value)
      quantitatET.value = LiniesCampET.quantitat.value
      quantitatET_distribuida.value = LiniesCampET.quantitat_distribuida.value
      quantitat_botigues_ET.value = LiniesCampET.campaignsLines.value.length
    }
    //getEstat()
    mapaGeneral()
    LlistatFotos(zonesUniques)
}

function getEstat() {
  return calcularEstatActual(idCamp,loadServeis(idCamp))
}


const mapaGeneral = () => {
  const idOdoo = id.value.split('/').pop()

  urlMapa.value = 'https://dashboard.traycco.com/code/mapes/mapa_webclient.php?localitzador=1&id='+idCamp+
                  '&idOdoo='+idOdoo+
                  '&capa='+mapa.value+
                  '&z=&filtre='+mapaFiltreBotiga.value+
                  '&tienda='+botigaFiltre.value+
                  '&dataIni='+data_ini.value+
                  '&dataFi='+data_fi.value+
                  '&idClient='+ClientId.value+
                  '&fotos_mapa='+fotos_al_mapa.value

                 // console.log (urlMapa.value)
}

const mapaLinia = (item) => {
  const idOdoo = id.value.split('/').pop()

  urlMapaLinia.value = 'https://dashboard.traycco.com/code/mapes/mapa_webclient.php?localitzador=1&id='+idCamp+
                  '&idOdoo='+idOdoo+
                  '&capa='+mapa.value+
                  '&z='+item.zone_id+
                  '&filtre='+mapaFiltreBotiga.value+
                  '&tienda='+item.shop+
                  '&dataIni='+data_ini.value+
                  '&dataFi='+data_fi.value+
                  '&idClient='+ClientId.value

  ZonaMapaLinia.value = item.zone_id
  PoblacioMapaLinia.value = item.zone_city
  ProvinciaMapaLinia.value = item.zone_state_id
  showMapaLinia.value = true;
}

const exportarTaula = (items) => {
  const excludedKeys = ['id','estadoDistribucion', 'mapa','distributed'];

  const nomsAmables = {
    distribute_date: 'Fecha de reparto',
    zone_state_id: 'Provincia',
    zone_id: 'Zona Traycco',
    cp: 'CP',
    zone_city: 'Población',
    quantity: 'Cantidad',
    shop: 'Tienda',
    flyer_reference: 'Ref. folleto',
    hora_inici: 'Hora de inicio',
    punt_inici: 'Punto de inicio',
  };

  const dadesExportar = items.map(item => {
    const nouItem = {};

    for (const [clau, valor] of Object.entries(item)) {
      if (!excludedKeys.includes(clau)) {
        nouItem[clau] = valor;

        if (clau === 'zone_id' && valor) {
          nouItem['cp'] = String(valor).substring(0, 5);
        }
      }
    }

    return nouItem;
  });

  if (dadesExportar.length === 0) {
    alert('No hay datos para exportar');
    return;
  }

  const capsaleresTecnicas = Object.keys(dadesExportar[0]);
  const capsaleresTraduides = capsaleresTecnicas.map(k => nomsAmables[k] || k);
  const capsaleres = capsaleresTraduides.join(';');
  const files = dadesExportar.map(fila => Object.values(fila).join(';'));

  const csvContent = [capsaleres, ...files].join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.setAttribute('download', `campaña_${id.value}_export.csv`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

const LlistatFotos = async (zonesUniques) => {
  //console.log (zonesUniques)
    try {
        const { data } = await axios.post('/api/campaignsWeb/listFotos', {
          data_inici: data_ini.value,
          data_fi: data_fi.value,
          idclient: ClientId.value,
          ztList: zonesUniques
        });

        llistatFotos.value = data;
        num_fotos.value = data.length
    } catch (error) {

      if (error.response && error.response.status === 422) {
            const errors = error.response.data.errors;

            // Mostrar tots els missatges per consola
            for (const camp in errors) {
                console.warn(`${camp}: ${errors[camp][0]}`);
            }

            // Si vols mostrar el primer error a l'usuari:
            const primerError = Object.values(errors)[0][0];
            //alert(`Error de validació: ${primerError}`);
        } else {
            console.error('Error inesperat:', error);
            //alert('Hi ha hagut un error inesperat');
        }
    }
};

function onFotoDeleted(fotoId) {
  llistatFotos.value = llistatFotos.value.filter(f => f.gid !== fotoId)
}

function onUpdateServei(value) {
  //console.log ("onupdate" + value)
  if (value == 'bm') {
    startMinimized.value = false
    startMinimizedET.value = true
    startMinimizedMapa.value = false
    visibleBM.value = true
    visibleET.value = false
    visibleMapa.value = true
  } else if (value == 'et') {
    startMinimized.value = true
    startMinimizedET.value = false
    startMinimizedMapa.value = true
    visibleBM.value = false
    visibleET.value = true
    visibleMapa.value = false
  } else {
    // Serveis especials tipus azafata. Utilitza la taula de BM pero es comporta com ET (no mapa, ocupa tota la pantalla)
    startMinimized.value = false
    startMinimizedET.value = true
    startMinimizedMapa.value = false
    visibleBM.value = true
    visibleET.value = true
    visibleMapa.value = false
  }

}


onMounted(() => {
  //Auth de l'usuari de plataforma
  const data = localStorage.getItem('clientSession')

  if (data) {
    clientSession.value = JSON.parse(data)
    if (clientSession.value['role']  == 'admin') {
      admin.value = true
    } else {
      admin.value = false
    }
    ClientId.value = clientSession.value['client_id']
    ClientLogo.value = clientSession.value['logo']
    ClientImage.value = clientSession.value['image']
    fotos_al_mapa.value = clientSession.value['fotos_al_mapa']

    if (!botigaFiltre.value && (clientSession.value['IdBotiga'] || clientSession.value['IdBotiga'])) {
      botigaFiltre.value = String(clientSession.value['IdBotiga'] || clientSession.value['IdBotiga'])
    }

  }

  CapCampanya()

})
</script>

<style >
.image-wrapper {
  position: relative;
  overflow: hidden;
  display: inline-block;
  border-radius: 8px;
  width: 100%;
}

/* Zoom suau */
.zoom-image {
  transition: transform 0.3s ease;
}

/* Quan el contenidor és en hover, aplica escala a la imatge */
.image-wrapper:hover .zoom-image {
  transform: scale(1.05);
}
</style>
